import {
    GET_PROMOCODE_LISTING,
    GET_PROMOCODE_LISTING_SUCCESS,
    GET_PROMOCODE_LISTING_FAIL,
    GET_PROMOCODE_DETAILS,
    GET_PROMOCODE_DETAILS_SUCCESS,
    GET_PROMOCODE_DETAILS_FAIL,
    ADD_PROMOCODE,
    ADD_PROMOCODE_SUCCESS,
    ADD_PROMOCODE_FAIL,
    UPDATE_PROMOCODE,
    UPDATE_PROMOCODE_SUCCESS,
    UPDATE_PROMOCODE_FAIL,
    DELETE_PROMOCODE,
    DELETE_PROMOCODE_SUCCESS,
    DELETE_PROMOCODE_FAIL,
    EXPORT_PROMOCODE,
    EXPORT_PROMOCODE_SUCCESS,
    EXPORT_PROMOCODE_FAIL,
    RESET_PROMOCODE_STATE,
    RESET_PROMOCODE_ATTACHMENT_STATE,
} from "./actionTypes";

export const getPromocodeListing = (promocode) => ({
    type: GET_PROMOCODE_LISTING,
    payload: promocode,
});

export const getPromocodeListingSuccess = promocode => ({
    type: GET_PROMOCODE_LISTING_SUCCESS,
    payload: promocode,
});

export const getPromocodeListingFail = error => ({
    type: GET_PROMOCODE_LISTING_FAIL,
    payload: error,
});

export const getPromocodeDetails = promocodeId => ({
    type: GET_PROMOCODE_DETAILS,
    payload: promocodeId,
});

export const getPromocodeDetailsSuccess = promocode => ({
    type: GET_PROMOCODE_DETAILS_SUCCESS,
    payload: promocode,
});

export const getPromocodeDetailsFail = error => ({
    type: GET_PROMOCODE_DETAILS_FAIL,
    payload: error,
});

export const createPromocode = promocode => ({
    type: ADD_PROMOCODE,
    payload: promocode,
});

export const createPromocodeSuccess = promocode => ({
    type: ADD_PROMOCODE_SUCCESS,
    payload: promocode,
});

export const createPromocodeFail = error => ({
    type: ADD_PROMOCODE_FAIL,
    payload: error,
});

export const updatePromocode = promocode => ({
    type: UPDATE_PROMOCODE,
    payload: promocode,
});

export const updatePromocodeSuccess = promocode => ({
    type: UPDATE_PROMOCODE_SUCCESS,
    payload: promocode,
});

export const updatePromocodeFail = error => ({
    type: UPDATE_PROMOCODE_FAIL,
    payload: error,
});

export const deletePromocode = promocodeId => ({
    type: DELETE_PROMOCODE,
    payload: promocodeId,
});

export const deletePromocodeSuccess = promocodeId => ({
    type: DELETE_PROMOCODE_SUCCESS,
    payload: promocodeId,
});

export const deletePromocodeFail = error => ({
    type: DELETE_PROMOCODE_FAIL,
    payload: error,
});

export const exportPromocode = data => ({
    type: EXPORT_PROMOCODE,
    payload: data,
});

export const exportPromocodeSuccess = data => ({
    type: EXPORT_PROMOCODE_SUCCESS,
    payload: data,
});

export const exportPromocodeFail = error => ({
    type: EXPORT_PROMOCODE_FAIL,
    payload: error,
});

//reset
export const resetPromocodeAttachmentState = () => {
    return {
        type: RESET_PROMOCODE_ATTACHMENT_STATE,
    }
}
export const resetPromocodeState = () => {
    return {
        type: RESET_PROMOCODE_STATE,
    }
}

